const types = require('../../constants/actionTypes');


const selected = ({ id }) => ({
    type: types.COUNTRY_EXPOSURE_SELECTED,
    payload: { id },
});


module.exports = selected;
